export default __webpack_public_path__ + "static/media/70.8c10cae6.svg";